import { VIMTUTOR_RAW, VimtutorRawType } from "src/sources/data/vimtutor.raw";
import { ExerciseEntity } from "src/sources/entities/exercise.entity";
import { MotionEntity } from "src/sources/entities/motion.entity";
import { TagEntity } from "src/sources/entities/tag.entity";
import { ExerciseType } from "src/sources/enums/exercise-type.enum";
import { SectionEntity } from "../entities/section.entity";

function generateMotions(raw: VimtutorRawType[]): MotionEntity[] {
  const rawMotions = raw.reduce(
    (acc: { motion: string; explanation: string }[], raw: VimtutorRawType) => {
      return acc.concat(raw.motions);
    },
    []
  );

  return rawMotions.map((rawMotion) => {
    return new MotionEntity(rawMotion.motion, rawMotion.explanation);
  });
}

function generateExercises(
  raw: VimtutorRawType[],
  allMotions: MotionEntity[],
  allTags: TagEntity[]
): ExerciseEntity[] {
  return raw.map((raw) => {
    const ex = new ExerciseEntity(
      raw.exerciseId,
      raw.title,
      raw.instructions,
      raw.initialState,
      raw.desiredState,
      raw.difficulty,
      raw.type as ExerciseType,
      raw.desiredCursorPosition
    );
    ex.motions = allMotions.filter((motion) => {
      return raw.motions.some((rawMotion) => {
        return rawMotion.motion === motion.motion;
      });
    });
    ex.tags = allTags.filter((tag) => {
      return raw.tagIds.some((rawTag) => {
        return rawTag === tag.name;
      });
    });

    return ex;
  });
}

function generateTags(raw: VimtutorRawType[]): TagEntity[] {
  const rawTags = raw.reduce((acc: string[], raw: VimtutorRawType) => {
    return [...acc, ...raw.tagIds];
  }, []);

  return rawTags.map((rawTag, idx) => {
    return new TagEntity(idx, rawTag, "");
  });
}

function generateSections(
  raw: VimtutorRawType[],
  exercises: ExerciseEntity[]
): SectionEntity[] {
  const s = new Set<string>();
  raw.forEach((r) => {
    s.add(r.section);
  });
  const uniqueSections = Array.from(s).sort();

  const sections: SectionEntity[] = uniqueSections.map((r) => {
    const section = new SectionEntity(`Section ${r}`, r);

    section.addExercises(
      exercises.filter((exercise) => {
        return exercise.title.substring(0, 8) === `Lesson ${r}`;
      })
    );
    return section;
  });

  return sections;
}

const motions = generateMotions(VIMTUTOR_RAW);
const tags = generateTags(VIMTUTOR_RAW);
const VIMTUTOR_EXERCISES = generateExercises(VIMTUTOR_RAW, motions, tags);
const VIMTUTOR_SECTIONS = generateSections(VIMTUTOR_RAW, VIMTUTOR_EXERCISES);

export { VIMTUTOR_SECTIONS, VIMTUTOR_EXERCISES, motions, tags };
